<script setup>
import { ref, reactive, computed } from "vue";

const releaseDialog = ref(false);

function releaseNotesDialogBox(status) {
  if (status == true) {
    releaseDialog.value = true;
  } else {
    releaseDialog.value = false;
  }
}
</script>

<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" class="d-flex align-stretch">
        <v-card
          class="justify-center align-center text-center mx-5"
          color="deep-orange-lighten-3"
          min-width="200"
        >
          <v-card-title
            ><v-img
              class="mx-auto justify-center ma-5"
              max-height="100"
              max-width="100"
              src="./images/deploy.png"
              cover
            >
            </v-img
            >Deploy to MDM</v-card-title
          >
          <v-card-text class="flex">
            Quickly deploy pre-configured configurations and settings to a
            targeted MDM.
          </v-card-text>
          <v-card-text
            >Collections containing multiple configuration items can also be
            used to standardise the deployment process.</v-card-text
          >
          <v-card-actions class="justify-center mb-2">
            <v-btn to="/mdmtools/deployment" variant="outlined"
              >Deploy to MDM</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card
          class="justify-center align-center text-center elevation-5 mx-5"
          color="green-lighten-3"
          min-width="200"
        >
          <v-card-title>
            <v-img
              class="mx-auto justify-center ma-5"
              max-height="100"
              max-width="100"
              src="./images/export.png"
              cover
            >
            </v-img>
            Export from MDM</v-card-title
          >
          <v-card-text class="flex">
            Export existing configurations from an MDM, either from multiple
            supported endpoints or select items.
          </v-card-text>
          <v-card-text>
            These exported items can be redeployed to other MDM tenants to help
            speed up the provisioning process.</v-card-text
          >
          <v-card-actions class="justify-center mb-2">
            <v-btn to="/mdmtools/export" variant="outlined"
              >Export from MDM</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card
          class="justify-center align-center text-center elevation-5 mx-5"
          color="yellow-lighten-3"
          min-width="200"
        >
          <v-card-title
            ><v-img
              class="mx-auto justify-center ma-5"
              max-height="100"
              max-width="100"
              src="./images/collectionEditor.png"
              cover
            >
            </v-img
            >Collection Editor</v-card-title
          >
          <v-card-text class="flex">
            Manage collections which group together multiple configuration
            items, speeding up and standardising deployments.
          </v-card-text>
          <v-card-text class="flex">
            New collections can be created, existing collections edited with
            amended items, or deleted.</v-card-text
          >
          <v-card-actions class="justify-center mb-2">
            <v-btn to="/mdmtools/collectioneditor" variant="outlined"
              >Review and edit</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card
          class="justify-center align-center text-center elevation-5 mx-5"
          color="blue-lighten-3"
          min-width="200"
        >
          <v-card-title>
            <v-img
              class="mx-auto justify-center ma-5"
              max-height="100"
              max-width="100"
              src="./images/itemEditor.png"
              cover
            >
            </v-img
            >Config Editor</v-card-title
          >
          <v-card-text class="flex">
            Manage exported and saved configuration items and preview their JSON
            payload.
          </v-card-text>
          <v-card-text class="flex">
            Saved configurations can also be renamed, have their descriptions
            updated, or deleted if no longer required.
          </v-card-text>
          <v-card-actions class="justify-center mb-2">
            <v-btn to="/mdmtools/configeditor" variant="outlined"
              >Review and edit</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" class="d-flex align-stretch mt-4">
        <v-card
          class="justify-center align-center text-center mx-5"
          color="teal-lighten-3"
          min-width="200"
        >
          <v-card-title
            ><v-img
              class="mx-auto justify-center ma-5"
              max-height="100"
              max-width="100"
              src="./images/export.png"
              cover
            >
            </v-img
            >Jamf Import</v-card-title
          >
          <v-card-text class="flex">
            Import objects from a Jamf Pro instance into reusable templates with
            automatic dependency resolution.
          </v-card-text>
          <v-card-text>
            Supports policies, scripts, profiles, prestages, groups, and more.
          </v-card-text>
          <v-card-actions class="justify-center mb-2">
            <v-btn to="/mdmtools/jamfexport" variant="outlined"
              >Import from Jamf</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card
          class="justify-center align-center text-center elevation-5 mx-5"
          color="purple-lighten-3"
          min-width="200"
        >
          <v-card-title>
            <v-img
              class="mx-auto justify-center ma-5"
              max-height="100"
              max-width="100"
              src="./images/deploy.png"
              cover
            >
            </v-img>
            Jamf Deploy</v-card-title
          >
          <v-card-text class="flex">
            Deploy saved templates into a target Jamf Pro instance with
            dependency-ordered imports.
          </v-card-text>
          <v-card-text>
            Optionally disable policies, remove scopes, and update existing
            objects.
          </v-card-text>
          <v-card-actions class="justify-center mb-2">
            <v-btn to="/mdmtools/jamfdeploy" variant="outlined"
              >Deploy to Jamf</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <v-card-actions class="justify-center mb-2">
        <v-btn @click="releaseNotesDialogBox(true)" variant="outlined"
          >Release Notes</v-btn
        >
      </v-card-actions>
    </v-row>
    <v-dialog v-model="releaseDialog">
      <v-container>
        <v-row justify="center">
          <v-col cols="5">
            <v-card class="mx-auto elevation-5" color="blue-lighten-3">
              <v-card-item>
                <v-card-title>Supported Profile Types - Tested</v-card-title>
                <v-card-subtitle
                  >Others may be available for export, but have not been
                  confirmed</v-card-subtitle
                >
              </v-card-item>
              <v-card-text>
                <v-card-text>
                  <ul>
                    <li>Configuration Profiles (All types)</li>
                    <li>Compliance Policies (Excluding message templates)</li>
                    <li>Filters</li>
                    <li>App Categories</li>
                    <li>Scripts (Windows, macOS and Linux)</li>
                    <li>Enrolment Status Page Profiles (Windows)</li>
                    <li>Deployment Profiles (Windows)</li>
                    <li>Update rings (Windows)</li>
                    <li>Applications*</li>
                    <li>
                      Endpoint Security;
                      <ul>
                        <li>Antivirus</li>
                        <li>Disk Encryption</li>
                        <li>Firewall</li>
                        <li>Attack Surface Reduction</li>
                        <li>Security Baselines (Windows 10 and later)</li>
                      </ul>
                    </li>
                  </ul>
                </v-card-text>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="4"
            ><v-card class="mx-auto elevation-5" color="green-lighten-3">
              <v-card-item>
                <v-card-title>Supported Platforms</v-card-title>
                <v-card-subtitle
                  >Only Windows has been fully tested</v-card-subtitle
                >
              </v-card-item>

              <v-card-text>
                <v-card-text>
                  <ul>
                    <li>Windows</li>
                    <li>iOS/iPadOS</li>
                    <li>macOS</li>
                    <li>Android</li>
                    <li>Linux (Compliance policy and scripts only)</li>
                  </ul>
                </v-card-text>
              </v-card-text>
            </v-card>
            <br />
            <v-card class="mx-auto elevation-5" color="red-lighten-3">
              <v-card-item>
                <v-card-title>Disabled</v-card-title>
                <v-card-subtitle>Requires further testing</v-card-subtitle>
              </v-card-item>
              <v-card-text>
                <v-card-text>
                  <ul>
                    <li>Applications;*</li>
                    <ul>
                      <li>macOS and iOS Apps & Books applications</li>
                      <li>iOS-iPadOS built-in managed apps</li>
                      <li>
                        LOB, or apps requiring a separate installer upload
                      </li>
                    </ul>
                  </ul>
                </v-card-text>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </v-container>
</template>
